var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json-wrapper",class:{ 'is-dark': _vm.$themeDark }},[_c('vue-json-pretty',{attrs:{"data":_vm.data,"deep":_vm.deep},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }